import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import React, { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { focusCloseButton, IFormModalRef, reactModalProps } from '../modal';

export interface IFormResetConfirmationModal {
    onCloseAndContinue: React.EventHandler<any>;
}

const FormResetConfirmationModal = (
    props: IFormResetConfirmationModal,
    ref: ForwardedRef<IFormModalRef>
) => {
    const { t } = useTranslation();
    const [modalIsOpen, setModalIsOpen] = useState(false);

    useEffect(() => {
        if (!modalIsOpen) {
            document.body.classList.remove('modal-open');
        } else {
            focusCloseButton();
        }
    }, [modalIsOpen]);

    useImperativeHandle(ref, () => {
        return {
            setModalOpen(value: boolean) {
                setModalIsOpen(value);
            },
        };
    });

    const closeAndContinue = () => {
        setModalIsOpen(false);
        props.onCloseAndContinue(null);
    };

    ReactModal.setAppElement('#root');
    return (
        <ReactModal
            aria-label={t('modal_reset_container_aria_label', { ns: 'accessibility' })}
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            contentLabel={t('form_modal_start_over_description')}
            {...reactModalProps}
        >
            <button
                className="modal__close-icon"
                onClick={() => setModalIsOpen(false)}
                aria-label={t('modal_close_aria_label', { ns: 'accessibility' })}
                id="modal_close_button"
            >
                <span className="visuallyhidden">
                    {t('modal_close_aria_label', { ns: 'accessibility' })}
                </span>
                <span aria-hidden="true">×</span>
            </button>
            <div className="body-medium">
                <div className="modal-bottom-element">{t('form_modal_start_over_description')}</div>
                <div className="modal-center-button-container">
                    <button
                        className="button button--primary modal-center-button"
                        onClick={closeAndContinue}
                    >
                        {t('form_modal_start_over_cta')}
                    </button>
                </div>
            </div>
        </ReactModal>
    );
};

export default forwardRef(FormResetConfirmationModal);
